<template>
    <div class="container">
      <div class="searchBox">
        <el-form :inline="true" :model="serchParam" class="demo-form-inline">
          <el-form-item>
            <el-input class="input" v-model="serchParam.companyNameOrAddress"  placeholder="机构名称/机构地址" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="serchParam.companyCategoryId" placeholder="机构类别" clearable filterable>
              <el-option v-for="(item,index) in allCategoryArray" :key="index" :label="item.companyCategoryName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="serchParam.companyLevel" placeholder="机构级别" clearable filterable>
              <el-option v-for="(item,index) in companyLevelArray" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-cascader placeholder="行政区划" :change-on-select="true" clearable filterable :props="defaultProps" v-model="serchParam.zone" :options="zoneArray"  expand-trigger="hover"></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList()" class="search">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table">
        <tableList ref="tableList" :serchParam="serchParam"  @detail="detail"/>
      </div>
      <el-dialog title="详细信息" :visible.sync="dialogVisible">
        <div class="infoBox">
            <div><span class="name">机构名称：</span><span style="font-weight: bold;">{{companyInfo.companyName}}</span></div>
            <div><span class="name">机构地址：</span><span>{{companyInfo.companyDetailAddress}}</span></div>
            <div><span class="name">行政区划：</span><span>{{companyInfo.areaName + ' ' + companyInfo.streetName}}</span></div>
            <div><span class="name">机构类别：</span><span>{{companyInfo.companyCategoryName}}</span></div>
            <div><span class="name">机构级别：</span><span>{{jigjb[companyInfo.companyLevel]}}</span></div>
            <div><span class="name">经营性质：</span><span>{{jingyxz[companyInfo.businessNature]}}</span></div>
            <div><span class="name">服务对象：</span><span>{{fuwdx[companyInfo.serviceObject]}}</span></div>
            <div><span class="name">服务方式：</span><span>{{companyInfo.serviceMethodName}}</span></div>
            <div><span class="name">诊疗科目：</span><span>{{companyInfo.medicalSubject}}</span></div>
            <div><span class="name">床位数：  </span><span>{{companyInfo.bedNum}}</span></div>
            <div><span class="name">牙椅数：  </span><span>{{companyInfo.teethChairNum}}</span></div>
            <div><span class="name">联系电话：</span><span>{{companyInfo.phone}}</span></div>
            <div><span class="name">备注：    </span><span>{{companyInfo.remark}}</span></div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">退出详情</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import tableList from './pageTable';
        export default {
        components:{
          tableList
        },
        data() {
            return {
              allCategoryArray:[],
              companyLevelArray:[
                {name: '一级', id: 0},
                {name: '二级', id: 1},
                {name: '三级', id: 2},
                {name: '无级别', id: 3},
                {name: '未定级', id: 4},
              ],
              serchParam:{
                companyNameOrAddress:'',
                companyCategoryId:'',
                companyLevel:'',
                regionId:'',
              },
              defaultProps: {
                children: 's',
                label: 'n',
                value: 'v',
                expandTrigger: 'hover'
              },
              zoneArray:[],
              companyInfo:{},
              dialogVisible: false,
              jingyxz: {
                0: '营利性',
                1: '非营利性(政府办)',
                2: '非营利性(非政府办)'
              },
              fuwdx: {
                0: '内部',
                1: '社会',
                2: '社会+内部'
              },
              jigjb: {
                0: '一级',
                1: '二级',
                2: '三级',
                3: '无级别',
                4: '未定级',
              }
            }
        },
        created(){
          this.getAllCategory();
          this.initZoneArray();
        },
        methods:{
          //获取行政区划
          initZoneArray(){
            const url = '/api/siteselection/zone/getAllRegionByCityId'
            this.axios.post(url,{cityId: this.$store.state.userInfo.user.region}).then( res =>{
                this.zoneArray = res.data;
            });
          },
          //机构类别(经济类型)
          getAllCategory(){
            const url = '/api/siteselection/companyCategory/getAllCategory';
            this.axios.post(url,{}).then( res =>{
                this.allCategoryArray = res.data.model;
            });
          },
          getList(){
            const Length = this.serchParam.zone ? this.serchParam.zone.length : 0;
            this.serchParam.regionId = Length > 0 ? this.serchParam.zone[Length-1] : '';
            this.$refs.tableList.fillTableData();
          },
          detail(id){
            const url = '/api/siteselection/company/getCompanyInfoById';
            this.axios.post(url,{id:id}).then( res =>{
                if(res.data.code == '00000'){
                this.companyInfo = res.data.model;
                this.dialogVisible = true 
                }
            });
          },
        }
    }
</script>

<style lang="less" scoped>
  .searchBox{
    background: white;
    padding: 20px;
    .el-form{
      display: flex;
    }
    .el-form-item{
        margin-bottom: 0;
    }
    /deep/.input .el-input__inner{
      width:250px;
    }
    .search{
      width: 80px;
      font-size: 16px;
    }
    /deep/.el-input__inner {
      color: #000000;
      font-size: 16px;
      &::placeholder {
        color: #666;
      }
    }
  }
  .table{
    margin-top: 12px;
    /deep/.cell{
      color: #333;
      font-size: 14px;
    }
    /deep/.el-button{
      font-size: 14px;
    }
  }
  /deep/.el-dialog{
    width: 600px;
    margin-top: 0!important;
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;
    .el-dialog__header{
        padding: 20px;
    }
    .el-dialog__body{
        border-top: 1px solid #ccc;
        padding: 28px 28px 10px;
    }
    .el-dialog__footer{
        text-align: center;
        button{
            padding: 0;
            width: 218px;
            height: 36px;
            line-height: 36px;
            background: #1F8FFF;
            border-radius: 3px;
        }
    }
  }
  .infoBox{
    max-height: 76vh;
    overflow-y: auto;
    div{
        margin-bottom: 16px;
        font-size: 16px;
        color: #333333;
        .name{
            color: #999999;
        }
    }
  }
  /deep/.el-dialog__wrapper{
    overflow: hidden!important;;
  }
</style>
